export function healthRecordGenderToProfileGender(gender: "M" | "F"): "m" | "f" {
  return gender === "M" ? "m" : "f";
}
